var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLaunchRocket({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#launchRocket_svg__clip0_15630_148598)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#launchRocket_svg__clip1_15630_148598)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.948 2.05a10.649 10.649 0 00-8.48 4.988l-.002.003-.002.002-.085.135-1.436 2.872 2.035 2.036a18.912 18.912 0 003.023-1.55c3.954-2.657 4.827-6.178 4.947-8.486zm-5.164.25A11.851 11.851 0 008.72 5.985a11.262 11.262 0 00-1.339-.26 7.242 7.242 0 00-1.567-.046c-.53.049-1.089.184-1.557.496-.808.54-1.298 1.583-1.58 2.36a10.75 10.75 0 00-.423 1.515l-.001.008v.003l.806.479-.807-.478-.128.708h4.838l2.268 2.268v4.838l.709-.128-.108-.592.108.592h.003l.008-.002.026-.005c.023-.005.055-.01.095-.02a10.76 10.76 0 001.395-.398c.776-.282 1.818-.772 2.359-1.58.312-.468.447-1.028.497-1.557a7.24 7.24 0 00-.047-1.568 11.27 11.27 0 00-.256-1.325c4.461-3.183 5.148-7.428 5.148-9.858V.837l-.598-.003A11.851 11.851 0 0012.784 2.3zM7.228 6.918c.298.038.578.09.816.142a19.815 19.815 0 00-1.241 2.508H3.607a9.25 9.25 0 01.2-.623c.275-.758.659-1.462 1.118-1.77.24-.16.579-.26 1-.299a6.055 6.055 0 011.303.042zm3.204 9.475v-3.194c.865-.35 1.704-.758 2.512-1.224.05.234.1.507.138.797.056.431.08.886.042 1.303-.04.421-.14.761-.3 1-.306.46-1.01.843-1.769 1.118-.221.08-.434.146-.623.2zm-7.538-2.754a2.505 2.505 0 013.343.104l.004.003.004.004c.93.918.923 2.401.116 3.357-.352.419-.847.736-1.343.979a9.594 9.594 0 01-1.548.576 14.845 14.845 0 01-1.844.399h-.009l-.002.001h-.001l-.08-.596-.596-.08v-.003l.001-.009.005-.031.017-.113a14.88 14.88 0 01.377-1.7 9.596 9.596 0 01.577-1.548c.242-.496.56-.991.979-1.343zm-1.36 4.827l.08.596-.78.105.104-.78.596.08zM3.28 14.1l.387.46c-.236.2-.464.525-.672.95-.204.42-.37.895-.501 1.352-.089.31-.16.604-.214.86.255-.056.55-.126.86-.215.456-.13.932-.297 1.35-.501.426-.208.752-.436.95-.672l.002-.002c.43-.51.408-1.277-.039-1.722a1.302 1.302 0 00-1.735-.05l-.388-.46zm11.046-7.617a.686.686 0 11-1.371 0 .686.686 0 011.371 0zm1.203 0a1.888 1.888 0 11-3.777 0 1.888 1.888 0 013.777 0z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "launchRocket_svg__clip0_15630_148598"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "launchRocket_svg__clip1_15630_148598"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.833 .833)",
    d: "M0 0h18.333v18.333H0z"
  })))));
}

export default SvgLaunchRocket;